import { CostCenterColumns } from '../entities/cost-center-items/cost-center-columns.enum';
import { TextKeys } from '../../i18n/text-keys';
import { TableColumn } from '../../models/table-column';
import {CostCenterFilterOptionsModel} from '../../models/cost-center/cost-center-filter-options.model';

export const getTableColumns = (): TableColumn[] => [
  {
    name: CostCenterColumns.Number,
    position: 0,
    selected: true,
    text: TextKeys.costCenter.numberShort,
  },
  {
    name: CostCenterColumns.Name,
    position: 1,
    selected: true,
    text: TextKeys.costCenter.title,
  },
];

export const getCostCenterFilterOptions = (): CostCenterFilterOptionsModel => ({
  number: {
    name: TextKeys.costCenter.numberShort,
    selected: false,
  },
  name: {
    name: TextKeys.costCenter.title,
    selected: false,
  },
});
